<div class="container" [style.background-color]="data.color">
  <svg *ngIf="data.icon" [icon]="data.icon" class="svg24 white-color" />
  <div class="text-container">{{ data.message }}</div>
  <button class="btn-empty" (click)="close()">
    <svg [icon]="closeIcon" class="svg24 white-color" />
  </button>
</div>
